import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

const menuItems = [{
  name: 'Centre d’aide',
  link: '/help-center'
}, {
  name: 'Mention Légale',
  link: '/legal-notice'
}, {
  name: 'Contact',
  link: '/contact'
}, {
  name: 'Politique de Cookies',
  link: '/cookie-policy'
}];

const FooterBottom = ({ textColor = 'text-white', borderColor = 'border-white/20' }) => {
  return (
    <div className={`pt-6 md:pt-8 border-t text-xs md:text-sm font-medium ${borderColor}`}>
      <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-6">
        <div className={`${textColor} text-center md:text-left mb-2 md:mb-0`}>
          © {new Date().getFullYear()} GoNextMaker. Tous droits réservés.
        </div>

        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-6">
          <div className={`flex flex-wrap justify-center gap-2 md:gap-4 ${textColor}`}>
            {menuItems.map((item) => (
              <a key={item.name} href={item.link} className="hover:opacity-70 whitespace-nowrap">
                {item.name}
              </a>
            ))}
          </div>

          <button className={`flex items-center gap-2 px-4 py-2 bg-dark-1 ${textColor} rounded-full`}>
            <FontAwesomeIcon icon={faGlobe} size="sm" />
            <span>English</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;